import { Component } from '@angular/core';

@Component({
    selector: 'app-payments-menu',
    templateUrl: './payments-menu.component.html',
    styleUrls: ['./payments-menu.component.css'],
    standalone: false
})
export class PaymentsMenuComponent {

  constructor() { }

}
